import { supabase } from '../lib/supabase';

export function useActivity() {
  async function getActivity(userId, limit = 20) {
    if (!userId) return [];
    try {
      const [quotesRes, invoicesRes] = await Promise.all([
        supabase
          .from('quotes')
          .select('id, client_name, trade_type, total, status, created_at, updated_at')
          .eq('user_id', userId)
          .order('updated_at', { ascending: false })
          .limit(limit),
        supabase
          .from('invoices')
          .select('id, client_name, total, status, created_at, updated_at')
          .eq('user_id', userId)
          .order('updated_at', { ascending: false })
          .limit(limit),
      ]);

      const events = [];

      for (const q of (quotesRes.data || [])) {
        events.push({
          id: `q_${q.id}_${q.status}`,
          type: 'quote',
          status: q.status,
          client: q.client_name,
          detail: q.trade_type,
          amount: q.total,
          ts: q.updated_at || q.created_at,
          quoteId: q.id,
        });
      }

      for (const inv of (invoicesRes.data || [])) {
        events.push({
          id: `inv_${inv.id}_${inv.status}`,
          type: 'invoice',
          status: inv.status,
          client: inv.client_name,
          amount: inv.total,
          ts: inv.updated_at || inv.created_at,
          invoiceId: inv.id,
        });
      }

      // Sort by timestamp descending
      events.sort((a, b) => new Date(b.ts) - new Date(a.ts));
      return events.slice(0, limit);
    } catch {
      return [];
    }
  }

  return { getActivity };
}
